// import React from 'react'
// import "./AccountSidebar.css"
// import { Link, useLocation, useNavigate } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux';
// import { loginMethod } from '../../hook/auth';
// function AccountSidebar() {
//     const { currentLocal } = useSelector((state) => state.currentLocal);

//   const location = useLocation();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();


//   return (
//     <section className='account_sidebar_container'>
//       <h3>Personal Information</h3>
//       <div className='account_sidebar_box'>
//         <div >
//           <Link className={location.pathname.substring(1) === 'account_setting' ? 'active sidebar-item' : "sidebar-item"} to="/account_setting">My Account</Link>
//           <Link className={location.pathname.substring(1) === 'user/orders' ? 'active sidebar-item' : "sidebar-item"} to="/user/orders">My Orders</Link>
//           <Link className={location.pathname.substring(1) === 'user/track_order' ? 'active sidebar-item' : "sidebar-item"} to="/user/track_order">{currentLocal.home.TrackOrder}</Link>
//           <Link className={location.pathname.substring(1) === 'user/addressbook' ? 'active sidebar-item' : "sidebar-item"} to="/user/addressbook">My Address</Link>
//           {/* <Link className={location.pathname.substring(1) === 'user/coupon' ? 'active sidebar-item' : "sidebar-item"} to="/user/coupon">My Cupons</Link> */}
//           <Link className="sidebar-item border-bottom-0" data-toggle="modal" data-target="#exampleModalCenter" >Logout</Link>

//           <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
//             <div className="modal-dialog modal-dialog-centered" role="document">
//               <div className="modal-content">
//                 <div className="modal-header border-bottom-0 d-flex justify-content-end py-1">
//                   <button type="button" className="close" data-dismiss="modal" aria-label="Close">
//                     <span aria-hidden="true" className='fs-3'>&times;</span>
//                   </button>
//                 </div>
//                 <div className="modal-body py-1 text-center">
//                   Are You Sure You Want to Logout

//                 </div>
//                 <div className="modal-footer border-top-0 d-flex justify-content-center">



//                   <button
//                     type="button"
//                     className="btn bg-light text-black fw-bold px-4"
//                     data-dismiss="modal"
//                     aria-label="Close"
//                       >Close</button>
//                   <button
//                     type="button"
//                     className="btn bg-danger text-white fw-bold px-4"
//                     data-dismiss="modal"
//                     aria-label="Close"
//                         onClick={() => {
//                       dispatch(loginMethod({}))
//                       navigate('/')

                      
//                     }}
//                   >Logout</button>



//                 </div>
//               </div>
//             </div>
//           </div>


//         </div>
//       </div>



//     </section>
//   )
// }

// export default AccountSidebar

import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { loginMethod } from '../../hook/auth';
import { Modal, Button } from 'react-bootstrap';
import "./AccountSidebar.css"

function AccountSidebar() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <section className='account_sidebar_container'>
      <h3>{currentLocal.home.Personalinformation}</h3>
      <div className='account_sidebar_box'>
        <div>
          <Link className={location.pathname.substring(1) === 'account_setting' ? 'active sidebar-item' : "sidebar-item"} to="/account_setting">{currentLocal.home.profile}</Link>
          <Link className={location.pathname.substring(1) === 'user/orders' ? 'active sidebar-item' : "sidebar-item"} to="/user/orders">{currentLocal.home.myOrder}</Link>
          <Link className={location.pathname.substring(1) === 'user/track_order' ? 'active sidebar-item' : "sidebar-item"} to="/user/track_order">{currentLocal.home.TrackOrder}</Link>
          <Link className={location.pathname.substring(1) === 'user/addressbook' ? 'active sidebar-item' : "sidebar-item"} to="/user/addressbook">{currentLocal.home.myAddresses}</Link>
          
          {/* زر تسجيل الخروج */}
          <span className="sidebar-item border-bottom-0" onClick={handleShow}>  {currentLocal.home.logout}</span>
        </div>
      </div>

      {/* المودال */}
      <Modal show={show} onHide={handleClose} centered>
  
        <Modal.Body className='text-center'>
{currentLocal.home.logoutState}
        </Modal.Body>
        <Modal.Footer className='justify-content-center'>
          <Button variant="light" onClick={handleClose}>{currentLocal.home.close}</Button>
          <Button variant="danger" onClick={() => {
            dispatch(loginMethod({}));
            navigate('/');
            handleClose();
          }}>
          {currentLocal.home.logout}
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}

export default AccountSidebar;
